import { devInfo } from './devLog';

/**
 * Marcas de cold-start. Por defecto silenciosas.
 * Para depurar: EXPO_PUBLIC_BOOT_TIMING=1
 */
function isBootTimingEnabled(): boolean {
  try {
    return typeof process !== 'undefined' && process.env?.EXPO_PUBLIC_BOOT_TIMING === '1';
  } catch {
    return false;
  }
}

const t0 = Date.now();
const marks = new Map<string, number>();

export function markBoot(label: string): void {
  if (typeof __DEV__ === 'undefined' || !__DEV__) return;
  if (!isBootTimingEnabled()) return;
  const at = Date.now();
  marks.set(label, at);
  const prev = [...marks.entries()].filter(([k]) => k !== label).at(-1);
  const delta = prev ? at - prev[1] : at - t0;
  devInfo(`[boot] ${label} +${at - t0}ms (Δ${delta}ms)`);
}

export function resetBootTiming(): void {
  marks.clear();
}
